import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { translate, Trans } from "react-i18next";
import { _addNotification, _addNotificationError } from '../../server/util';
import { declinedReasonList } from '../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import { postWithHeaders } from "../../server/actionsParent";
import moment from 'moment';

class Draft extends Component {
  constructor(props) {
    super(props);
    this.state = {
      draftData: {}
    }
    this.formatDraftReqObj - this.formatDraftReqObj.bind(this);
  }
  componentDidMount = () => {
    this._notificationSystem = this.refs.notificationSystem;
    this.formatDraftReqObj();
  }
  formatDraftReqObj = () => {
    let reqBody = {};
    reqBody.date = moment().format('MMDDYYYY');
    reqBody.status = "draft";
    console.log("this.props:::::", this.props);

    if (this.props.lunchObj.hasOwnProperty("applicationId")) {
      reqBody.applicationId = this.props.lunchObj.applicationId;
    }
    reqBody.allFoster=this.props.lunchObj.isAllFoster;
    reqBody.incomeAfter=this.props.lunchObj.isIncomeAfter;
    reqBody.mealSchoolId = this.props.lunchObj.mealSchoolId;
    reqBody.prmyParentEmail = this.props.lunchObj.persons[0].contact.email
    reqBody.schoolYear = this.props.schoolInfo.sessionYear || (this.props.lunchObj && this.props.lunchObj.date && this.props.lunchObj.date.slice(-4));

    let persons = [];
    this.props.lunchObj.persons.map((person, p) => {
      person.assistancePrograms = this.props.lunchObj.assistancePrograms;
      persons.push(person)
    });
    let studentArray = []
    this.props.lunchObj.studentList.map((student, p) => {
      if (student.isSelected) {
        if (student.liveUnderFosterCare === true) {
          student.income = [];
        }
        if (this.props.lunchObj.isIncomeAfter === false) {//user want to submitted without income details 
          student.income = [];
        }
        studentArray.push(student.studentRecId)
        persons.push(student)
      }
    });
    reqBody.studentRecIds = studentArray.join(',');

    this.props.lunchObj.childList.map((child, p) => {
      persons.push(child)
    });
    this.props.lunchObj.adultList.map((adult, p) => {
      persons.push(adult)
    });
    reqBody.declinedReasonList = declinedReasonList.slice();
    reqBody.householdAppInfo = persons;

    this.setState({ draftData: reqBody });
  }
  saveDraftLunchBreakfast = () => {
    let headers = {
      'Content-Type': 'application/json'
    };
    let reqBody = this.state.draftData;
    let _serStatusCode = '';

    let url = '/householdApplication?'
    if (this.props.schoolInfo.districtStatus) {
      url = '/familyApplication?'
    }
    console.log("ReqBody::::::::::::", reqBody);

    postWithHeaders(url, JSON.stringify(reqBody), headers, false, true)
      .then((resp) => {
        if (!resp.ok) {
          throw Error(resp.errorMessage);
        }
        return resp.json();
      }).then(data => {
        if (data.statusCode === 200) {
          _addNotification("successfully saved data", this);
          setTimeout(() => {
            window.location.reload();
          }, 1000)
          // this.props.jumpToStep(17);
        } else {
          _addNotificationError(data.statusMessage, this);
        }
      }).catch(
        (error) => {
          console.log('Details not saved', error);
          _addNotificationError(<Trans>{`Please try again!`}</Trans>, this);
        }
      );
  }
  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
        <div>
          <button className="btn btn-prev btn-xs bg-color-1 pull-right" onClick={this.saveDraftLunchBreakfast}>
            <Trans>Save As Draft</Trans>
          </button>
        </div>
      </div>
    );
  }
}

export default Draft;



// WEBPACK FOOTER //
// ./src/components/FreeReducedProgram/draft.js